export const SystemApp={
  base_url: 'http://tobalight.co.il/',
  base_url_api: 'http://tobalight.co.il:8000'
}
